import { observeElement, getWidget } from '@uvocore-front/utils';

/* eslint-disable */
import './style.scss';
import { tns } from 'tiny-slider/src/tiny-slider';

if (document.querySelector('[data-testimonials-list]')) {
  const testimonialConfig = () => {
    let config = {
      type: 'html',
      moreEl: '.testimonials__more-btn',
      containerEl: '[data-testimonials-list]',
      params: {
        siteId: 107,
        limit: 6,
      },
      loader: true,
    };

    if (document.querySelector('.testimonials-page')) {
      config.template = i => `<div class="testimonials-item">
            <div class="testimonials-item__inner">
              <div class="testimonials-item__text">
                ${i.body}
              </div>
              <div class="testimonials-item__customer">
                Customer
              </div>
            </div>
          </div>`;
    } else {
      config.template = i => `<div class="testimonials__item testimonials-item">
            <div class="testimonials-item__inner">
              <div class="testimonials-item__text">
                ${i.body}
              </div>
              <div class="testimonials-item__customer">
                Customer
              </div>
            </div>
          </div>`;
        config.loader = false;
      }
    return config;
  };

  observeElement({
    element: '[data-testimonials-list]',
    marginValue: 300,
    callback: () => {
      if (
        document.querySelector('[data-testimonials-list]').dataset.testimonialsList === 'home' &&
        document.querySelector('[data-testimonials-slider]')
      ) {
        tns({
          'container': '[data-testimonials-slider]',
          'slideBy': 'page',
          'controls': false,
          'nav': true,
          'mouseDrag': true,
          'responsive': {
            0: {
              'edgePadding': 0,
              'gutter': 8,
              'items': 1
            },
            768: {
              'items': 2,
              'gutter': 16
            },
            1024: {
              'gutter': 30,
            }
          }
        });
      } else {
        getWidget({
          widgetLink: '/assets/js/testimonialsWidget.min.js',
          loader: true,
          fn: () => {
            const configOut = [
              testimonialConfig(),
              {
                callbackLoaded: () => {
                  if (document.querySelector('[data-testimonials-slider]')) {
                    tns({
                      'container': '[data-testimonials-slider]',
                      'slideBy': 'page',
                      'controls': false,
                      'nav': true,
                      'mouseDrag': true,
                      'responsive': {
                        0: {
                          'edgePadding': 0,
                          'gutter': 8,
                          'items': 1
                        },
                        768: {
                          'items': 2,
                          'gutter': 16
                        },
                        1024: {
                          'gutter': 30,
                        }
                      }
                    });
                  }
                }
              }
            ];

            const result = configOut.reduce(function (arr, item) {
              Object.keys(item).forEach(k => (arr[k] = item[k]));
              return arr;
            }, {});

            window.tmWidget(result);
          },
        });
      }
    },
  });
}
